import { createSlice } from '@reduxjs/toolkit'

const persistSlice = createSlice({
  name: 'persistSlice',
  initialState: {
    buData: null,
    analysisData: [],
    materialData: [],
    buCodeData: null,
    requestData: [],
    requestTypeData: [],
    enteredUserData: [],
    analysisDataSelect: [],
    selectedMaterialData: [],
    editableLineData: [],
    orderBuId: 0,
    requestListData: [],
    paymentData: [],
    copyRequestData: {},
    paymentDataCard: [],
    paymentDataCardAmount: [],
    orderPersistData: [],
    requestTabIndex: "1",
    materialCloneData: []

  },
  reducers: {
    updateBuData: (state, action) => {
      state.buData = action.payload
    },
    updateAnalysisData: (state, action) => {
      state.analysisData = action.payload
    },
    updateMaterialData: (state, action) => {
      state.materialData = action.payload
    },
    updateCloneMaterialData: (state, action) => {
      state.materialCloneData = action.payload
    },
    updateBuCodeData: (state, action) => {
      state.buCodeData = action.payload
    },
    updateRequestData: (state, action) => {
      state.requestData = action.payload
    },

    updateRequestTypeData: (state, action) => {
      state.requestTypeData = action.payload
    },
    updateEnteredUserData: (state, action) => {
      state.enteredUserData = action.payload
    },
    updateAnalysisDataSelect: (state, action) => {
      state.analysisDataSelect = action.payload
    },
    updateSelectedMainData: (state, action) => {
      state.selectedMainData = action.payload
    },
    updateSelectedMaterialData: (state, action) => {
      state.selectedMaterialData = action.payload
    },
    updateEditableLineData: (state, action) => {
      state.editableLineData = action.payload
    },
    updateOrderBuId: (state, action) => {
      state.orderBuId = action.payload
    },
    updateRequestListData: (state, action) => {
      state.requestListData = action.payload
    },
    updatePaymentData: (state, action) => {
      state.paymentData = action.payload
    },
    updatePaymentDataCard: (state, action) => {
      state.paymentDataCard = action.payload
    },
    updateCopyRequestData: (state, action) => {
      state.copyRequestData = action.payload
    },
    updatePaymentDataAmountCard: (state, action) => {
      state.paymentDataCardAmount = action.payload
    },
    updateOrderPersistData: (state, action) => {
      state.orderPersistData = action.payload
    },
    updateRequestTabIndex: (state, action) => { state.requestTabIndex = action.payload },

  },
})

export const {
  updateBuData,
  updateAnalysisData,
  updateMaterialData,
  updateBuCodeData,
  updateRequestData,
  updateRequestTypeData,
  updateEnteredUserData,
  updateAnalysisDataSelect,
  updateSelectedMaterialData,
  updateSelectedMainData,
  updateEditableLineData,
  updateOrderBuId,
  updateRequestListData,
  updatePaymentData,
  updateCopyRequestData,
  updatePaymentDataCard,
  updatePaymentDataAmountCard,
  updateOrderPersistData,
  updateRequestTabIndex,
  updateCloneMaterialData
} = persistSlice.actions

export const persistDataReducer = persistSlice.reducer